module.exports = __webpack_public_path__ + "img/select.ab5522bd.svg";